<template>
    <section
        v-if="!anonymousSession"
        class="mt-4 shrink-0 rounded-xl border border-theme-divider-soft bg-[color-mix(in_srgb,var(--theme-icons-background)_40%,var(--theme-background-color))] p-4"
    >
        <div class="mb-3 flex items-center justify-between">
            <span class="text-sm font-semibold text-theme-text">{{ localizations[lang].quickHighlight }}</span>
            <BaseToggleSwitch
                :value="quickHighlight.enabled"
                :label="localizations[lang].quickHighlight"
                :tooltip="localizations[lang].quickHighlightTooltip"
                @toggle="setQuickHighlightEnabledAndSave"
            />
        </div>

        <span class="mb-2 block text-sm font-semibold text-theme-text">
            {{ localizations[lang].yourHighlighters }}
        </span>
        <HighlighterColorPicker
            :selected-slug="quickHighlightColor.colorSlug"
            :disabled="!quickHighlight.enabled || quickHighlightToggleSaveInFlight"
            @select="handleColorSelect"
        />
    </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import BaseToggleSwitch from '../../Components/buttons/BaseToggleSwitch.vue';
import HighlighterColorPicker from '../../HighlighterColorPicker/HighlighterColorPicker.vue';

export default {
    name: 'QuickHighlightSection',

    components: {
        BaseToggleSwitch,
        HighlighterColorPicker,
    },

    computed: {
        ...mapState([
            'anonymousSession',
            'quickHighlight',
            'quickHighlightToggleSaveInFlight',
            'localizations',
            'lang',
        ]),
        ...mapGetters(['quickHighlightColor']),
    },

    methods: {
        ...mapActions(['setQuickHighlightEnabledAndSave', 'setQuickHighlightColorAndSave']),

        /**
         * Persists the picked color as the active one; ignored while the mode is off.
         * @param {{ slug: string, color: string }} payload - Color selected in the picker
         */
        handleColorSelect(payload) {
            if (!this.quickHighlight.enabled || this.quickHighlightToggleSaveInFlight) return;
            this.setQuickHighlightColorAndSave(payload.slug);
        },
    },
};
</script>
